import Vue from 'vue'
import store from '../store/index'
import 'cookieconsent'
import 'cookieconsent/build/cookieconsent.min.css'
import VueGtm from 'vue-gtm'

window.cookiesAccepted = () => {
  // init stripe
  const stripeScript = document.createElement('script')
  stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
  document.body.appendChild(stripeScript)

  // init paypal
  const paypalClientId = (process.env.NODE_ENV === 'development' ? 'AU24zBDgDhiyfkx_dJqd5bi6cHdzttHi1xmToGS-0MCr7LSODAiE82MhFBjfg56r8tF4Ra5p8Wl8lLXi' : 'AR_LUj8IEoSMPsxmszfD4N30v0WCCTGS0cs2JGRswdwmE1CGxo0S2PjdvxkjCTxclQrdzXJr9Mew-fPt')
  const paypalScript = document.createElement('script')
  paypalScript.setAttribute('src', 'https://www.paypal.com/sdk/js?client-id=' + paypalClientId + '&currency=EUR&components=buttons&disable-funding=venmo,paylater,card')
  document.body.appendChild(paypalScript)
 
  // init vytal
  const vytalScript = document.createElement('script')
  vytalScript.setAttribute('src', 'https://web.vytal.org/web-login-sdk/v1.0/vytal-web-login-sdk.js')
  document.body.appendChild(vytalScript)

  const vytalStyles = document.createElement('link')
  vytalStyles.rel = 'stylesheet'
  vytalStyles.type = 'text/css'
  vytalStyles.href = 'https://web.vytal.org/web-login-sdk/v1.0/vytal-web-login.css'
  document.head.appendChild(vytalStyles)

  const vytalFonts = document.createElement('link')
  vytalFonts.rel = 'stylesheet'
  vytalFonts.type = 'text/css'
  vytalFonts.href = 'https://fonts.googleapis.com/css?family=Roboto'
  document.head.appendChild(vytalFonts)

  // load tag manager
  Vue.use(VueGtm, {
    id: 'GTM-PTGKSP2',
    enabled: true,
    debug: true,
    loadScript: true
  })
}

// See https://www.osano.com/cookieconsent/documentation/javascript-api/
window.cookieconsent.initialise({
  content: {
    header: 'Cookies aus dieser Webseite',
    message: 'Wir verwenden Cookies z.B. dazu, dass du nicht bei jeder Bestellung erneut deine Adresse eingeben musst und dazu, dass dir dieser Hinweis nicht ständig angezeigt wird 🤓<br />Alles zu unserem Umgang mit deinen Daten findest du unter',
    dismiss: 'Ok',
    allow: 'Cookies akzeptieren',
    deny: 'Cookies ablehnen',
    link: 'Mehr erfahren',
    href: '/datenschutz',
    close: '&#x274c;',
    policy: 'Cookies',
    target: '_blank'
  },
  type: 'opt-in',
  position: 'bottom',
  theme: 'block',
  palette: null,
  revokable: false,

  onPopupOpen () {
    // console.log('onPopupOpen')
  },

  onPopupClose () {
    // console.log('onPopupClose')
  },

  onInitialise () {
    if (this.hasConsented()) {
      window.cookiesAccepted()
      window.cookiesAcceptedByUser = true
    } else {
      window.cookiesAcceptedByUser = false
    }

    store.commit('cookies/setIsAccepted', this.hasConsented())
  },

  onStatusChange () {
    if (this.hasConsented()) {
      window.cookiesAccepted()
      window.cookiesAcceptedByUser = true
    } else {
      window.cookiesAcceptedByUser = false
    }

    store.commit('cookies/setIsAccepted', this.hasConsented())
  },

  onRevokeChoice () {
    // console.log('onRevokeChoice')
  }
})



// WEBPACK FOOTER //
// ./src/plugins/cookieconsent.js